import { Languages } from '../../shared/language/Language';
import { ActionType, createStandardAction } from 'typesafe-actions';

export const languageActions = {
  setLanguage: createStandardAction('LANGUAGE/SET_LANGUAGE')<{ language: Languages }>(),
};

export type LanguageAction = ActionType<typeof languageActions>;



// WEBPACK FOOTER //
// ./src/modules/language/actions.tsx